import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    realEstateAdminId: String,
  }

  static targets = ['arrowButton']

  moveUp(event) {
    const button = event.currentTarget
    const configurationId = button.dataset.configurationId
    this.moveConfiguration(configurationId, 'up', button)
  }

  moveDown(event) {
    const button = event.currentTarget
    const configurationId = button.dataset.configurationId
    this.moveConfiguration(configurationId, 'down', button)
  }

  moveConfiguration(configurationId, direction, button) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    this.disableAllButtons()

    const icon = button.querySelector('svg')
    const spinner = button.querySelector('.loading')
    if (icon) icon.classList.add('hidden')
    if (spinner) spinner.classList.remove('hidden')

    fetch(`/real_estate_admin/${this.realEstateAdminIdValue}/real_estate_admin_configuration/${configurationId}/move_${direction}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          window.location.reload()
        } else {
          this.resetButton(button, icon, spinner)
          this.enableAllButtons()
          this.showFlashMessage(data.message || 'Erro ao mover configuração.', 'error')
        }
      })
      .catch((error) => {
        console.error('Error moving configuration:', error)
        this.resetButton(button, icon, spinner)
        this.enableAllButtons()
        this.showFlashMessage('Erro ao mover configuração.', 'error')
      })
  }

  disableAllButtons() {
    this.arrowButtonTargets.forEach((btn) => {
      btn.disabled = true
      btn.classList.add('opacity-50')
    })
  }

  enableAllButtons() {
    this.arrowButtonTargets.forEach((btn) => {
      btn.disabled = false
      btn.classList.remove('opacity-50')
    })
  }

  resetButton(button, icon, spinner) {
    if (icon) icon.classList.remove('hidden')
    if (spinner) spinner.classList.add('hidden')
  }

  showFlashMessage(message, type) {
    window.showNotification(message, type)
  }
}
